import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaDonate } from 'react-icons/fa';
import LogoHeader from '../Assets/Image/Xtra-Grow-Foundation-Logo.png';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="logo text-center mb-4">
        <img src={LogoHeader} alt="Logo" style={{ height: '50px' }} />
      </div>
      <ul className="sidebar-nav list-unstyled px-1">
        <li>
          <NavLink to="/dashboard" end className="d-flex align-items-center gap-2">
            <FaHome /> Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/donationdetails" end className="d-flex align-items-center gap-2">
            <FaDonate /> Donation Details
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
